import { StyledEngineProvider } from "@mui/material/styles";
import { AppRouterCacheProvider } from "@mui/material-nextjs/v14-appRouter";

export const DreamServerThemeProvider = ({ children }: React.PropsWithChildren) => (
  <AppRouterCacheProvider options={{ key: "css", enableCssLayer: true }}>
    <StyledEngineProvider>{children}</StyledEngineProvider>
  </AppRouterCacheProvider>
);
